(function() {
  'use strict';

  angular.module('ringbaPortal').directive('trStatsDetail', trStatsDetail);

  function trStatsDetail() {
    const directive = {
      restrict: 'E',
      scope: { stat: '<'},
      controller: 'StatsDetailController',
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/components/statsdetail/stats-detail.view.html'
    };
    return directive;
  }
})();
